import React, { FC } from 'react'

import cn from 'classnames'

import classes from './loading-dots.module.scss'
import loading from '../../assets/images/general-icons/loading.svg'

interface LoadingDotsProps {
  className?: string
}

export const LoadingDots: FC<LoadingDotsProps> = ({ className }) => (
  <img
    alt="Loading icon"
    src={loading}
    className={cn(classes.root, className)}
  />
)

export default LoadingDots
